import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Customer from './components/Customer';
import Add from './components/Add';
import Settings from './components/Settings';
import PageWrapper from './layouts/PageWrapper';
import CustomerList from './pages/customerList';

function App() {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<Login />} />

        {/* All CRM pages share Navbar + Sidebar */}
        <Route path="/" element={<PageWrapper />}>
          <Route path="customer" element={<Customer />} />
          <Route path="add-customer" element={<Add />} />
          <Route path="settings" element={<Settings />} />
          <Route path='/customer-list' element={<CustomerList/>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
